import React, {useCallback, useEffect, useState} from 'react';
import VisibilityIcon from '@material-ui/icons/Visibility'
import GetAppIcon from '@material-ui/icons/GetApp';
import TableComponent from 'components/shared/TableComponent';
import Button from 'components/shared/Button';
import {CreditCheckColumn} from 'constants/application';
import strings from 'strings';
import './index.scss'
import VerificationDrawer from "../Summary/Summaries/SummaryDrawers/VerificationDrawer";
import VerificationPreview from "./VerificationPreview";
import AccessRequestAlert from 'components/shared/AccessRequestAlert';
import LoadingCircle from "../../../../LoadingCircle";
import AuthService from "../../../../../tools/AuthService";
import { Grid } from "@material-ui/core";
import {getVerificationRequestPreview, requestCustomVerification} from "../../../../../actions/applicants";
import CreditCost from 'components/shared/CreditCost'

const t = strings.APPLICANT.VERIFICATION

export function Verification(props) {
    const {
        applicationId,
        verificationList,
        verificationData,
        getVerifications,
        getVerificationData,
        saveVerificationReport,
        downloadFile,
        updateSummaryCard,
        creditCosts
    } = props
    const [open, setOpen] = useState(false)
    const [previewOpen, setPreviewOpen] = useState(false)
    const [previewData, setPreviewData] = useState(null)
    const [loading, setLoading] = useState({list: false, report: false, save: false, download: false, attach: false, perform: false});
    const [savedReport, setSavedReport] = useState(false)
    const { isReadOnlyUser, creditUsageEnabled } = AuthService.getClientFeatures()
    const storedUser = JSON.parse(localStorage.getItem('user') || '{}')
    const currentUser = AuthService.loggedInUser || storedUser
    const showLexisAccessRequest = currentUser?.showLexisAccessRequest === true
    const clientName = currentUser?.securityContext?.client?.clientName || ''
    const clientId = currentUser?.securityContext?.client?.clientId || ''
    const userEmail = currentUser?.email || ''

    const getList = useCallback(() => {
        setLoading(prev => ({...prev, list: true}))
        getVerifications(applicationId)
            .finally(() => setLoading(prev => ({...prev, list: false})))
    }, [getVerifications, applicationId])

    useEffect(() => {
        getList()
    }, [getList])

    useEffect(() => {
        const disableRadio = []
        verificationList.forEach(data => {
            if (data.status === strings.STATUS_NAMES.Hit_Completed)
                disableRadio.push(data.uuid)
        })
    }, [verificationList])

    const getVerificationPreview = () => {
        getVerificationRequestPreview(applicationId)().then((res) => {
            setPreviewData(res)
            setPreviewOpen(true)
        })
    }

    const handleSave = () => {
        setLoading(prev => ({...prev, save: true}))
        const payLoad = {
            reportUuid: verificationData?.uuid
        }
        saveVerificationReport(applicationId, payLoad)
            .then(() => {
                getList()
                onClose()
            })
            .finally(() =>
            {
                setLoading(prev => ({...prev, save: false}))
                updateSummaryCard()
            })
    }

    const handlePreviewSubmit = (formData) => {
        setLoading(prev => ({ ...prev, report: true, perform: true }))
        requestCustomVerification(applicationId, formData)()
            .then( res => {
                getList()
                if (res?.code === 'VALID') {
                    setPreviewOpen(true);
                }
            })
            .finally(() => {
                setLoading(prev => ({ ...prev, report: false, perform: false }))
                setPreviewOpen(false)
                setPreviewData(null)
            })
    }

    const onClose = () => {
        setOpen(false)
        setPreviewOpen(false)
        setSavedReport(false)
    }

    const handleDownload = pdfReportUuid => {
        setLoading(prev => ({...prev, download: true}))
        downloadFile(applicationId, pdfReportUuid || verificationData.pdfReportUuid, 'verification-report.pdf')
            .finally(() => setLoading(prev => ({...prev, download: false})))
    }

    const columns = CreditCheckColumn.map((item, index) => {
        if (item.dataField === 'action')
            item = {
                ...item, formatter: (cell, row, rowIndex) => {
                    if (!!row?.verificationStatusUuid) {
                        return (
                            <><VisibilityIcon color='primary' title='View Changes' onClick={async()  =>  {
                                setLoading(prev => ({ ...prev, openDrawer: true }))
                                await getVerificationData(applicationId, null,null, row.verificationStatusUuid)
                                setOpen(true)
                                setSavedReport(true)
                                setLoading(prev => ({ ...prev, openDrawer: false }))
                            }}/>
                                {!!row.pdfReportUuid &&
                                    <GetAppIcon className='mt-3p ml-3' color='primary'
                                                onClick={() => !loading.download && handleDownload(row.pdfReportUuid)}/>}
                            </>
                        )
                    }
                }
            }
        return item
    })

    function getEndIcon() {
        if (creditCosts){
            const costObj = creditCosts.find(cost => cost.requestType === 'LEXIS_VERIFICATION');
            return costObj ? costObj.creditCost : 0;
        }
        return 0;
    }

    if (showLexisAccessRequest) {
        return (
            <Grid container>
                <Grid item xs={12} className='m-3'>
                    <AccessRequestAlert
                        type="lexis"
                        clientName={clientName}
                        clientId={clientId}
                        userEmail={userEmail}
                    />
                </Grid>
            </Grid>
        )
    }

    return (
        <div className="uccContainer">
            <div className='uccTitleContainer'>
                <h5>{t.VERIFICATION}</h5>
            </div>

            <TableComponent
                data={verificationList}
                keyField='uuid'
                columns={columns}
                showPagination={false}
                loading={loading.list}
            />
            {!isReadOnlyUser &&
                <div className='uccBtnContainer'>
                    <Button
                        endIcon={creditUsageEnabled && creditCosts ?
                            <CreditCost cost={getEndIcon()} /> : undefined}
                        onClick={() => getVerificationPreview()}
                        loading={loading.perform} disabled={loading.perform}>
                        {t.PERFORM}
                        {loading.perform && <LoadingCircle inline size={20} />}
                    </Button>
                </div>
            }

            {loading.save && <LoadingCircle overlay />}

            {loading.perform && <LoadingCircle overlay />}

            {loading.openDrawer && <LoadingCircle overlay />}

            <VerificationPreview
                open={previewOpen}
                onClose={onClose}
                verificationData={previewData}
                onSubmit={handlePreviewSubmit}
                loading={loading.save}
            />
            <VerificationDrawer
            open={open}
            onClose={onClose}
            applicationId={applicationId}
            data={verificationData}
            savedReport={savedReport}
            handleSave={handleSave}
        >
        </VerificationDrawer>
        </div>
    );
}
